import React, { useState } from 'react';
import { DatePicker } from 'hamro-nepali-patro';

const TestNepaliDatePicker = () => {
  const [date, setDate] = useState('');
  return (
    <div style={{ padding: 40 }}>
      <h2>Nepali Date Picker Test</h2>
      <DatePicker value={date} onChange={setDate} inputProps={{ fullWidth: true, size: 'small' }} />
      <div style={{ marginTop: 20 }}>
        <strong>Selected Date (BS):</strong> {date}
      </div>
    </div>
  );
};

export default TestNepaliDatePicker;
